import { render } from "./Stat_Cards.vue?vue&type=template&id=bc4951b2&scoped=true"
import script from "./Stat_Cards.vue?vue&type=script&lang=js"
export * from "./Stat_Cards.vue?vue&type=script&lang=js"

import "./Stat_Cards.vue?vue&type=style&index=0&id=bc4951b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4951b2"]])

export default __exports__